import { LocalOverrides } from 'services';

/** Stores an individual Feature Flag's data */
class Flag {
  readonly description: string;
  readonly jira: string;
  readonly key: string;
  private readonly _active: boolean;
  private readonly _override: boolean;

  constructor(
    key: string,
    active: boolean,
    description: string,
    jira: string,
    override: boolean = false,
  ) {
    this._active = active;
    this.description = description;
    this.jira = jira;
    this.key = key;
    this._override = override;
  }

  /**
   * Get if flag is currently enabled (active) or not, accounting for local
   * storage overrides.
   */
  get active() {
    return this._override ? !this._active : this._active;
  }

  /** Get if flag's active state is currently overridded in local storage. */
  get isOverridden() {
    return this._override;
  }

  /** Create a new flag from current with toggled active state */
  toggle() {
    const active = this._active;
    const override = !this._override;
    const { description, jira, key } = this;

    override ? LocalOverrides.add(key) : LocalOverrides.remove(key);
    return new Flag(key, active, description, jira, override);
  }
}
export { Flag };
